import { atom } from "jotai";

export type AgendaMemberNote = {
  header: string;
  body: string;
  date: string;
  status: "HIGH" | "MEDIUM" | "STANDARD";
};

export const agendaMemberNotes_atom = atom<AgendaMemberNote | null>(null);
